import { LocationClosureModel } from "../../data/entities";
import { LocationClosureODataRepo, LocationClosureRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class LocationClosureService extends BaseEntityService<LocationClosureModel, LocationClosureRepo, LocationClosureODataRepo> {
  constructor(){
    super(new LocationClosureRepo(), new LocationClosureODataRepo());
  }

  async getAllClosuresByLocationIdAsync(locationId: number): Promise<LocationClosureModel[]> {
    return await this.repo.getAllClosuresByLocationIdAsync(locationId);
  }

  async insertClosureAsync(locationClosure: LocationClosureModel): Promise<LocationClosureModel>{
    return await this.repo.insertClosureAsync(locationClosure); 
  }
}

export default LocationClosureService;
